import React from 'react';

import QueryErrorState from 'components/DesignSystem/QueryErrorState';

export interface ListErrorBlockProps {
  /** Refaz a consulta da lista ("Tentar de novo"). */
  onRetry: () => void;
}

/**
 * Bloco de erro no lugar da lista da aba Meus Estudos (estado `error-initial`, .dc.html:260-266 e
 * 448-451), sobre o `QueryErrorState` do DS. "Tentar de novo" é o texto do design; o padrão do DS
 * continua "Tentar novamente". O `role="alert"` anuncia a falha, que troca a lista inteira.
 */
export default function ListErrorBlock({ onRetry }: ListErrorBlockProps) {
  return (
    <div role="alert">
      <QueryErrorState
        title="Não foi possível carregar seus estudos"
        message="Verifique sua conexão. Os filtros continuam aplicados."
        retryLabel="Tentar de novo"
        onRetry={onRetry}
      />
    </div>
  );
}
